import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Avatar } from "../components/Avatar";
import { PREVIEW_LAB_STEP } from "../data/previewContent";
import "../css/Duo.css";

export const Route = createFileRoute("/welcome/step-2")({
  component: WelcomeStep2,
});

function WelcomeStep2() {
  const navigate = useNavigate();
  const [selectedChoice, setSelectedChoice] = useState<number | null>(null);
  const [phase, setPhase] = useState<"answer" | "feedback">("answer");

  const step = PREVIEW_LAB_STEP;
  const isCorrect = selectedChoice === step.answerIndex;

  const handleCheck = () => {
    if (selectedChoice === null) return;
    setPhase("feedback");
  };

  const handleContinue = () => {
    navigate({ to: "/welcome/step-3" });
  };

  return (
    <div className="duo-root">
      {/* HUD */}
      <div className="duo-hud">
        <div className="duo-hud-left"></div>
        <div className="duo-progress">
          <div className="duo-progress-bar">
            <div className="duo-progress-fill" style={{ width: "50%" }}></div>
          </div>
          <div className="duo-progress-meta">Step 1 of 1</div>
        </div>
        <div className="duo-hud-right"></div>
      </div>

      {/* Stage */}
      <div className="duo-stage">
        <div className="duo-card">
          <div className="duo-card-body">
            {/* Question */}
            {step.question && (
              <div className="duo-bubble">
                <div className="duo-bubble-avatar">
                  <Avatar avatarId="byte" size={56} mood="neutral" />
                </div>
                <div className="duo-bubble-text" style={{ fontWeight: 600 }}>
                  {step.question}
                </div>
              </div>
            )}

            {/* Choices */}
            <div className="duo-choices">
              {step.choices.map((choice, index) => {
                const selected = selectedChoice === index;
                const isAnswer = index === step.answerIndex;
                const showFb = phase === "feedback";
                const state = showFb
                  ? (selected && isAnswer) || (!selected && isAnswer)
                    ? "ok"
                    : selected
                    ? "bad"
                    : "idle"
                  : selected
                  ? "active"
                  : "idle";

                return (
                  <div
                    key={index}
                    className={`duo-choice ${state}`}
                    onClick={() => phase === "answer" && setSelectedChoice(index)}
                  >
                    {choice}
                  </div>
                );
              })}

              {/* Explanation */}
              {phase === "feedback" && step.explanation && (
                <div className="duo-bubble-text" style={{ marginTop: 16 }}>
                  <strong>{isCorrect ? "Correct! " : "Not quite. "}</strong>
                  <span>{step.explanation}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="duo-cta">
        {phase === "answer" ? (
          <button
            className={`duo-btn primary ${selectedChoice === null ? "disabled" : ""}`}
            onClick={handleCheck}
            disabled={selectedChoice === null}
          >
            Check Answer
          </button>
        ) : (
          <button
            className="duo-btn success"
            onClick={handleContinue}
          >
            Continue →
          </button>
        )}
      </div>
    </div>
  );
}
